import { isEmpty } from 'lodash';

import { TCustomerField } from 'modules/checkout/domain/entities';
import { ICustomer } from 'shared/domain/entities';

import needsGuardianValidation from './needsGuardianValidation';

export default function isCustomerRegistrationIncomplete(
  customer: ICustomer | null,
  missingFields: TCustomerField[],
  confirmedGuardianDocument: string | null = null,
) {
  if (!customer) return false;

  return (
    !isEmpty(missingFields) ||
    needsGuardianValidation(customer, confirmedGuardianDocument)
  );
}
